import './App.css';
import { ThemeProvider, createMuiTheme } from '@material-ui/core';
import Main from './Pages/Main/Main';
import { JumbotronContextProvider } from './Context/JumbotronContext';
import { PresenterToolsContextProvider } from './Context/PresenterToolsContext';
import { ErrorContextProvider } from './Context/ErrorContext';
import ErrorStack from './components/StreamCenter/Errors/ErrorStack/ErrorStack';

function App(props) {

  /* Material UI themes */
  const DarkTheme = createMuiTheme({
    typography: {
      "fontFamily": `"Roboto", "Helvetica", "Arial", sans-serif`,
    },
    breakpoints: {
      values: {
        lg: 1281,
        md: 960,
      }
    },
    palette: {
      type: 'dark',
      primary: {
        main: props.primaryThemeColor
      },
      secondary: {
        main: "#FF0092",
        dark: "#19191F",
      },
      intakeInput: {
        main: "#111112",
      },
      intakeBackground: {
        main: "#1B1B1D"
      },
      inputBackgroundColor: {
        main: "#3E4044"
      },
      intakePaper: {
        main: "black"
      },
      intakeBlue: {
        main: "#00B6FF"
      },
      jumbotronBanner: {
        main: "#3E3E3E"
      },
      selectedMode: {
        main: "#5c5c5c"
      },
      background: {
        paper: "#242424",
        default: "#1A1A1C",
      },
      emojiIcon: {
        main: "white",
      },
      toAttendeeSelect: {
        main: "#505050"
      },
      tooltip: {
        main: "#DEDEDE"
      },
      errorMessage: {
        main: "#2a2c30"
      },
      bridgeItemHover: {
        main: "#1c1c1c"
      }
    },
    overrides: {
      MuiCssBaseline: {
        '@global': {
          '*': {
            'scrollbar-width': 'thin',
          },
          '*::-webkit-scrollbar': {
            width: '4px',
            height: '4px',
          }
        }
      }
    }
  });

  const LightTheme = createMuiTheme({
    typography: {
      "fontFamily": `"Roboto", "Helvetica", "Arial", sans-serif`,
    },
    breakpoints: {
      values: {
        lg: 1281,
        md: 960,
      }
    },
    palette: {
      type: 'light',
      primary: {
        main: props.primaryThemeColor
      },
      secondary: {
        main: "#FF0092",
        dark: "#f0f0f0"
      },
      intakeBlue: {
        main: "#00B6FF"
      },
      intakeBackground: {
        main: "#ededed",
      },
      background: {
        paper: "#e8e8e8"
      },
      inputBackgroundColor: {
        main: "white",
      },
      emojiIcon: {
        main: "grey"
      },
      selectedMode: {
        main: "#5c5c5c"
      },
      jumbotronBanner: {
        main: "#dbdbdb"
      },
      intakePaper: {
        main: "white",
      },
      toAttendeeSelect: {
        main: "#c9c9c9"
      },
      intakeInput: {

      },
      tooltip: {
        main: "#575757"
      },
      bridgeItemHover: {
        main: "#dbdbdb"
      },
      errorMessage: {
        main: "#edeef0"
      }
    },
    overrides: {
      MuiCssBaseline: {
        '@global': {
          '*': {
            'scrollbar-width': 'thin',
          },
          '*::-webkit-scrollbar': {
            width: '4px',
            height: '4px',
          }
        }
      }
    }
  })
  /**/

  return (
    <PresenterToolsContextProvider>
      <ErrorContextProvider>
        <JumbotronContextProvider>
          <ThemeProvider theme={props.theme === "dark" ? DarkTheme : LightTheme}>
            <div className="App">

              {/* <video id="testVideo"></video> */}

              <ErrorStack />

              <Main />

            </div>
          </ThemeProvider>
        </JumbotronContextProvider>
      </ErrorContextProvider>
    </PresenterToolsContextProvider>
  );
}

export default App;
